<script>
		import { user, view, send_data} from "../client.svelte.js";
		import {site_URL} from "../core.js";
		import Sidebar from "../elements/Sidebar.svelte";

		let search = $state("")
		let rubric = $state("")

		let rubrics = $derived([...new Set(user.sites.values().map(site => site.rubric).filter(Boolean))].sort())
		let groups = $derived(
			[ {label: "Dieses Abenteuer", sites: new Set(Object.values(view.adventure.sites)).values().map(siteID => user.sites.get(siteID)).filter(Boolean).toArray()},
			  {label: "Eigener Katalog", sites: user.sites.values().filter(site => site.owner === user.ID).toArray()},
			  {label: "Öffentlicher Katalog", sites: user.sites.values().filter(site => site.owner === 'PUBLIC').toArray()} ]
			.map(group => ({label: group.label, sites: group.sites.filter(matches)})) )
		$inspect(`SITESCAT - grouped sites`, groups)

		function matches(site) {
				const term = search.trim().toLowerCase()
				return (!term || site.name?.toLowerCase().includes(term) || site.ID.toLowerCase().includes(term)) &&
				       (!rubric || site.rubric === rubric)
		}

		const layer_count = (site) => Object.keys(site.layers ?? {}).length

		async function select_site(siteID) {
				await view.select_site(siteID)
				view.switch_layout('advt-siteDetails')
		}

		async function create_site() {
				await send_data("/site/_", {}, 'POST')
		}

		function pickup_site(e, site) {
				e.dataTransfer.setData("site/ID", site.ID)
				e.dataTransfer.effectAllowed = 'copy'
		}

</script>


<!-------------------------------- HTML -------------------------------------->

{#snippet filter()}
	<div class="field">
		<label for="siteSearch">Suche</label>
		<input id="siteSearch" placeholder="Name oder Kürzel" bind:value={search}>
	</div>
	<div class="field">
		<label for="siteRubric">Kategorie</label>
		<select id="siteRubric" bind:value={rubric}>
			<option value="">alle</option>
			{#each rubrics as rub}<option value={rub}>{rub}</option>{/each}
		</select>
	</div>
{/snippet}

<section id={view.layout.page}>
	<Sidebar flyout={filter} items={[
		{id: 'create', icon: 'plus', label: "Neuer Ort", title: "Neuen Ort erstellen", primary: true, onclick: create_site},
		{id: 'filter', help: 'siteSearch', icon: 'filter', label: "Filtern", flyout: "Orte filtern", active: !!(search || rubric)} ]}/>

	<article class="page">
		{#each groups as group (group.label)}
			<div class="group">
				<h3>{group.label} <span class="tag neutral">{group.sites.length}</span></h3>
				{#if group.sites.length}
					<div class="tileGrid" style:--tile-min="220px" style:--tile-ratio="16 / 10">
						{#each group.sites as site (site.ID)}
							<button class="card tile" title={site.ID} draggable=true ondragstart={(e) => pickup_site(e, site)}
							        onclick={() => select_site(site.ID)}>
								<div class="tileImg">
									<img src={site_URL(site)} alt={site.ID} onerror={(e) => e.target.style.visibility = 'hidden'}>
								</div>
								<div class="tileBody">
									<span>{site.name}</span>
									<span class="card-meta">{site.ID} · {layer_count(site)} {(layer_count(site) === 1) ? "Ebene" : "Ebenen"}</span>
								</div>
							</button>
						{/each}
					</div>
				{:else}
					<p class="empty">keine Orte</p>
				{/if}
			</div>
		{/each}
	</article>
</section>
